export default {
  namespaced: true,
  state: {
    pendingCount: 0,
    activeRequest: null, // { url, method, startTime }
    lastResult: null, // { url, method, success, duration, errorMessage }
    clearTimer: null,
  },
  getters: {
    isActive(state) {
      return state.pendingCount > 0;
    },
    activeRequest(state) {
      return state.activeRequest;
    },
    lastResult(state) {
      return state.lastResult;
    },
  },
  mutations: {
    START_REQUEST(state, { url, method, startTime }) {
      state.pendingCount++;
      state.activeRequest = { url, method, startTime };
      // Clear any pending auto-clear timer when a new request starts
      if (state.clearTimer) {
        clearTimeout(state.clearTimer);
        state.clearTimer = null;
      }
      state.lastResult = null;
    },
    FINISH_REQUEST(state, { success, duration, errorMessage }) {
      state.pendingCount = Math.max(0, state.pendingCount - 1);
      if (state.pendingCount === 0) {
        const url = state.activeRequest ? state.activeRequest.url : "";
        state.lastResult = { url, success, duration, errorMessage };
        state.activeRequest = null;
      }
    },
    CLEAR_RESULT(state) {
      state.lastResult = null;
    },
    SET_CLEAR_TIMER(state, timer) {
      if (state.clearTimer) {
        clearTimeout(state.clearTimer);
      }
      state.clearTimer = timer;
    },
  },
  actions: {
    startRequest({ commit }, payload) {
      commit("START_REQUEST", payload);
    },
    finishRequest({ commit, state }, payload) {
      commit("FINISH_REQUEST", payload);
      // Auto-clear the result after 5 seconds if no new requests are pending
      if (state.pendingCount === 0) {
        const timer = setTimeout(() => {
          commit("CLEAR_RESULT");
        }, 5000);
        commit("SET_CLEAR_TIMER", timer);
      }
    },
  },
};
